
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Aboutus from './components/pages/Aboutus';
import Contact from './components/pages/Contact';
import HomeShift from './components/pages/HomeShift';
import OfficeShifting from './components/pages/OfficeShifting';
import CarRelocation from './components/pages/CarRelocation';
import AtmRelocation from './components/pages/AtmRelocation';
import Wirehouse from './components/pages/Wirehouse';
import International from './components/pages/International';
import CityRelocation from './components/pages/CityRelocation';
import Photopage from './components/pages/Photopage';
import Videopage from './components/pages/Videopage';
import Baguiati from './components/pages/Baguiati';
import Newtown from './components/pages/Newtown';
import Kalyani from './components/pages/Kalyani';
import Kolkata from './components/pages/Kolkata';
import Berhampore from './components/pages/Berhampore';
import Krishnagar from './components/pages/Krishnagar';
import Chennai from './components/pages/Chennai';
import Bengaluru from './components/pages/Bengaluru';
import Hyderabad from './components/pages/Hyderabad';
import Delhi from './components/pages/Delhi';
import Murshidabad from './components/pages/Murshidabad';
import Malda from './components/pages/Malda';
import Siliguri from './components/pages/Siliguri';
import Darjeeling from './components/pages/Darjeeling';
import Assam from './components/pages/Assam';
import Bankura from './components/pages/Bankura';
import Birbhum from './components/pages/Birbhum';
import Durgapur from './components/pages/Durgapur';
import Midnapore from './components/pages/Midnapore';
import Nadia from './components/pages/Nadia';
import Bardhaman from './components/pages/Bardhaman';
import Patna from './components/pages/Panta';
import Bihar from './components/pages/Bihar';
import Odisha from './components/pages/Odisha';
import Asansol from './components/pages/Asansol';
import Howrah from './components/pages/Howrah';
import Kharagpur from './components/pages/Kharagpur';
import Jalpaiguru from './components/pages/Jalpaiguru';
import BikeRelocation from './components/pages/BikeRelocation';
import IbaApproved from './components/pages/IbaApproved';
import Rajarhat from './components/pages/Rajarhat';
import Certicficate from './components/pages/Certicficate';
import BiswabanglaGateNewtown from './components/pages/BiswabanglaGateNewtown';


function App() {
  return (
    <Router>

      <div>



        <Routes>

          <Route axact path="/" element={<Home />} />
          <Route axact path="/aboutus" element={<Aboutus />} />
          <Route axact path="/contact-us" element={<Contact />} />
          <Route axact path="/home-shifting" element={<HomeShift />} />
          <Route axact path="/office-shifting" element={<OfficeShifting />} />
          <Route axact path="/car-relocation" element={<CarRelocation />} />
          <Route axact path="/atmrelocation" element={<AtmRelocation />} />
          <Route axact path="/WarehouseStorage" element={<Wirehouse />} />
          <Route axact path="/International-relocation" element={<International />} />
          <Route axact path="/CityRelocation" element={<CityRelocation />} />
          <Route axact path="/photo-gallery" element={<Photopage />} />
          <Route axact path="/video-gallery" element={<Videopage />} />
          <Route axact path="/Baguiatie-packers-movers-west-bengal" element={<Baguiati />} />
          <Route axact path="/Newtown-packers-movers-west-bengal" element={<Newtown />} />
          <Route axact path="/Kalyani-packers-movers-west-bengal" element={<Kalyani />} />
          <Route axact path="/Kolkata-packers-movers-west-bengal" element={<Kolkata />} />
          <Route axact path="/Berhampore-packers-movers-west-bengal" element={<Berhampore />} />
          <Route axact path="/Krishnagar-packers-movers" element={<Krishnagar />} />
          <Route axact path="/Chennai-packers-movers" element={<Chennai />} />
          <Route axact path="/Bengaluru-packers-movers" element={<Bengaluru />} />
          <Route axact path="/Hyderabad-packers-movers" element={<Hyderabad />} />
          <Route axact path="/Delhi-packers-movers" element={<Delhi />} />
          <Route axact path="/Murshidabad-packers-movers-westbengal" element={<Murshidabad />} />
          <Route axact path="/Malda-packers-movers-westbengal" element={<Malda />} />
          <Route axact path="/siliguri-packers-movers-westbengal" element={<Siliguri />} />
          <Route axact path="/Darjeeling-packers-movers-westbengal" element={<Darjeeling />} />
          <Route axact path="/Assam-packers-movers" element={<Assam />} />
          <Route axact path="/Bankura-packers-movers" element={<Bankura />} />
          <Route axact path="/Birbhum-packers-movers" element={<Birbhum />} />
          <Route axact path="/Durgapur-packers-movers" element={<Durgapur />} />
          <Route axact path="/Midnapore-packers-movers" element={<Midnapore />} />
          <Route axact path="/Nadia-packers-movers-westbengal" element={<Nadia />} />
          <Route axact path="/Bardhaman-packers-movers-westbengal" element={<Bardhaman />} />
          <Route axact path="/Patna-packers-movers" element={<Patna />} />
          <Route axact path="/Bihar-packers-movers" element={<Bihar />} />
          <Route axact path="/Odisha-packers-movers" element={<Odisha />} />
          <Route axact path="/Asansol-packers-movers" element={<Asansol />} />
          <Route axact path="/Howrah-packers-movers" element={<Howrah />} />
          <Route axact path="/Kharagpur-packers-movers" element={<Kharagpur />} />
              <Route axact path="/Jalpaiguru-packers-movers" element={<Jalpaiguru/>}/>
               <Route axact path="/bike-relocation" element={<BikeRelocation/>}/>
                <Route axact path="/IBAapproved-packersmovers" element={<IbaApproved/>}/>
                   <Route axact path="/Rajarhat-packers-movers" element={<Rajarhat/>}/>
                    <Route axact path="/certificate" element={<Certicficate/>}/>
                      <Route axact path="/BiswabanglaGateNewtown-packers-movers" element={<BiswabanglaGateNewtown/>}/>


        </Routes>
        <Footer />

      </div>

    </Router>
  );
}

export default App;
